<template>
  <button :class="['ui-button-btn', `ui-button-${color}`]">
    <span>{{ text }}</span>
  </button>
</template>
<script>
export default {
  props: {
    text: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: 'green'
    }
  }
}
</script>
<style lang="sass">
.ui-button-btn
    @apply bg-white text-gray-800 font-bold rounded border-b-2 shadow-md py-2 w-full inline-flex items-center

.ui-button-green
    @apply border-green-500
    &:hover
        @apply border-green-600 bg-green-500 text-white

.ui-button-yellow
    @apply border-yellow-500
    &:hover
        @apply border-yellow-600 bg-yellow-500 text-white
</style>
